// extracted by mini-css-extract-plugin
export default {"titleContainer":"titleContainer___zSc5O","title":"title___rxQtw"};